// ProgressStatusBar.js
var ProgressStatusBar = pc.createScript('progressStatusBar');

ProgressStatusBar.attributes.add('currentLevel', {type: 'entity'});
ProgressStatusBar.attributes.add('nextLevel', {type: 'entity'});
ProgressStatusBar.attributes.add('progressImage', {type: 'entity'});
ProgressStatusBar.attributes.add('progressImageMaxWidth', {type: 'number'});
ProgressStatusBar.attributes.add('NewRankLabel', {type: 'entity'});
ProgressStatusBar.attributes.add('userScore', {type: 'entity'});

ProgressStatusBar.prototype.initialize = function() {
    ProgressStatusBar.instance = this;
    this.updateScore();
};

ProgressStatusBar.prototype.updateScore = function() {
    
    let userCurrentStatus = detectCurrentLevel();
    this.currentLevel.element.text = userCurrentStatus[0].toUpperCase();
    
    this.setProgress(userCurrentStatus[2]);
    if (PlayerManager.instance.userData.userScore >= 100000) {
        this.userScore.element.text = PlayerManager.instance.userData.userScore;
        this.nextLevel.element.text = "---";
    }
    else {
        this.userScore.element.text = PlayerManager.instance.userData.userScore + " / " + userCurrentStatus[3];
        this.nextLevel.element.text = userCurrentStatus[1].toUpperCase();
    }
    this.checkNewRank();
};

ProgressStatusBar.prototype.checkNewRank = function() {

    let rankBar = this.NewRankLabel;

    if (currentRankName.toUpperCase() != this.currentLevel.element.text) {
        currentRankName = this.currentLevel.element.text;
        
        this.NewRankLabel.enabled = true;
        this.NewRankLabel.children[0].element.text = "New rank: " + this.currentLevel.element.text + "!";
        this.NewRankLabel.tween(this.NewRankLabel.getLocalPosition()).to(new pc.Vec3(0, -293.728, 0), 2, pc.SineOut).on('complete', function () { setTimeout(function() { ProgressStatusBar.instance.newRankSlideTop(rankBar); }, 2000,this);}).start();
    }
};

ProgressStatusBar.prototype.newRankSlideTop = function(inputEntity) {
    inputEntity.tween(inputEntity.getLocalPosition()).to(new pc.Vec3(0, -212.981, 0), 2, pc.SineOut).on('complete', function(){inputEntity.enabled = false; }).start();
};

ProgressStatusBar.prototype.setProgress = function (value) {    

    value = pc.math.clamp(value, 0, 1);
    this.progress = value;

    var width = pc.math.lerp(0, this.progressImageMaxWidth, value);
    this.progressImage.element.width = width;
    //this.progressImage.element.rect.z = value;
    this.progressImage.element.rect = this.progressImage.element.rect;
};


